"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _app = require("@package/app");

var _dicts = require("@package/dicts");

var _table = require("@package/table");

var _dialog = require("@package/dialog");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireWildcard(require("react"));

var _Roles = _interopRequireDefault(require("./Roles"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function getRoleName(key) {
  var role = _dicts.ROLES.filter(function (item) {
    return item['value'] === key;
  })[0];

  return role ? role['caption'] : null;
}

function Employees(_ref) {
  var onLoaded = _ref.onLoaded,
      onEdit = _ref.onEdit,
      onRemove = _ref.onRemove,
      openDialog = _ref.openDialog,
      users = _ref.users,
      isEditable = _ref.isEditable;

  try {
    var handleEdit = function handleEdit(userId) {
      onEdit(userId);
    };

    var handleRemove = function handleRemove(userId) {
      onRemove(userId);
    };

    var handleConfirm = function handleConfirm(uuid) {
      openDialog("remove-confirm-" + uuid);
    };

    var showRolesDialog = function showRolesDialog() {
      openDialog('rolesDialog');
    };

    (0, _react.useEffect)(function () {
      onLoaded && onLoaded();
    }, []);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['block']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['block__part']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['block__content']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['block__title']
    }, "\u041A\u043E\u043C\u0430\u043D\u0434\u0430", /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['block__title-link'],
      onClick: showRolesDialog
    }, "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0440\u043E\u043B\u0435\u0439")), /*#__PURE__*/_react["default"].createElement(_table.Table, {
      className: _defaultModule["default"]['block__table'],
      columns: users,
      _data: "options.users"
    }, /*#__PURE__*/_react["default"].createElement(_table.Column, {
      align: "center",
      width: "20",
      alias: "myself"
    }, function (isMyself) {
      return /*#__PURE__*/_react["default"].createElement("p", null, isMyself ? /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])(_defaultModule["default"]['icon'], 'icon-crown'),
        "data-locator": "employees.myself"
      }) : /*#__PURE__*/_react["default"].createElement("span", {
        className: _defaultModule["default"]['point'],
        "data-locator": "employees.user"
      }));
    }), /*#__PURE__*/_react["default"].createElement(_table.Column, {
      title: "\u0418\u043C\u044F \u0438 \u0444\u0430\u043C\u0438\u043B\u0438\u044F",
      align: "left",
      width: "215"
    }, function (_ref2) {
      var name = _ref2.name,
          myself = _ref2.myself;
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])(_defaultModule["default"]['name'], (0, _defineProperty2["default"])({}, _defaultModule["default"]['bold'], myself))
      }, name, myself ? ' (вы)' : '', " ");
    }), /*#__PURE__*/_react["default"].createElement(_table.Column, {
      title: "Email",
      align: "left",
      width: "170"
    }, function (_ref3) {
      var email = _ref3.email,
          myself = _ref3.myself;
      return /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
        className: (0, _classnames["default"])(_defaultModule["default"]['email'], (0, _defineProperty2["default"])({}, _defaultModule["default"]['bold'], myself))
      }, email);
    }), /*#__PURE__*/_react["default"].createElement(_table.Column, {
      title: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
      align: "left",
      width: "195"
    }, function (_ref4) {
      var phone = _ref4.phone,
          myself = _ref4.myself;
      return /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
        className: (0, _classnames["default"])(_defaultModule["default"]['phone'], (0, _defineProperty2["default"])({}, _defaultModule["default"]['bold'], myself))
      }, phone && phone.replace(/(\+\d)(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 ($2) $3-$4-$5'));
    }), /*#__PURE__*/_react["default"].createElement(_table.Column, {
      alias: "roles",
      title: "\u0420\u043E\u043B\u0438",
      align: "left",
      width: "390"
    }, function (roles) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: _defaultModule["default"]['roles']
      }, roles.map(function (role, index) {
        var roleName = getRoleName(role);
        return roleName ? /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
          key: index,
          className: _defaultModule["default"]['role']
        }, roleName) : null;
      }));
    }), isEditable && /*#__PURE__*/_react["default"].createElement(_table.Column, {
      width: "56px"
    }, function (model) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_storybook.Settings, {
        items: [{
          title: 'Редактировать',
          onClick: function onClick() {
            return handleEdit(model['id']);
          }
        }, {
          title: 'Удалить',
          onClick: function onClick() {
            return handleConfirm(model['id']);
          }
        }]
      }), /*#__PURE__*/_react["default"].createElement(_dialog.Confirm, {
        title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430?",
        message: "\u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A \u043D\u0435 \u0431\u0443\u0434\u0435\u0442 \u0438\u043C\u0435\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0443",
        caption: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
        name: "remove-confirm-" + model['id'],
        mode: "danger",
        onConfirm: handleRemove.bind(null, model['id'])
      }));
    })))), /*#__PURE__*/_react["default"].createElement(_dialog.Dialog, {
      name: "rolesDialog",
      title: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0440\u043E\u043B\u0435\u0439",
      align: 'top'
    }, /*#__PURE__*/_react["default"].createElement(_Roles["default"], null)));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Employees;
exports["default"] = _default;